export const getFragmentFromLocation = ({
  hash
}) => hash && hash.length ? hash.replace('#', '') : null;